/*jshint esversion: 6 */
// export const GRAPHQL_PORT = 10102;
const GRAPHQL_PATH = '/api/graphql';
// export const GRAPHQL_SUBSCRIPTION_PORT = 10103;
 const GRAPHQL_SUBSCRIPTION_PATH = '/api/subscriptions';

/**
 * to demonstrate how auth would work,
 * we use these jwt tokens
 */
const JWT_PRIVATE_KEY = '26452948404D635166546A576E5A7234753777217A25432A462D4A614E645267'; // H256
const JWT_BEARER_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJyeGRiIiwiaWF0IjoxNjA0MTg4Njk3LCJ' +
    'leHAiOjIyNjY4NzY2OTcsImF1ZCI6InJ4ZGIuaW5mbyIsInN1YiI6InVzZXJAcnhkYi5pbmZvIn0.hNEC3V4LpkEvGnLeT8hNTXTCZRPpMVDwaltH-8zh4Iw';

const accessMethodSchema = {
    title: 'accessMethod',
    primaryKey: 'id',
    type: 'object',
    version: 8,
    properties: {
        id: {
          type: 'string',
          maxLength: 36
        },
        readableId:{
          type: 'string'
        },
        name: {
          type: 'string'
        },
        type: {
          type: 'number'
        },
        textEntryDifficulty: {
          type: 'number'
        },
        textEntryDescription: {
          type: 'string'
        },
        uiNavigationDifficulty: {
          type: 'number'
        },
        uiNavigationDescription: {
          type: 'string'
        },
        itemSelectionMethod: {
          type: 'number'
        },
        itemSelectionDescription: {
          type: 'string'
        },
        advancedItemSelectionDescription: {
          type: 'string'
        },
        category: {
          type: 'string'
        },
        subCategory: {
          type: 'string'
        },
        typicalAccessPoints: {
          type: 'array',
          items: {
            type: 'string'
          }
        },
        possibleAccessPoints: {
          type: 'array',
          items: {
            type: 'string'
          }
        },
        movementRequired: {
          type: 'number'
        },
        movementRequireDescription: {
          type: 'string'
        },
        communcationConnection: {
          type: 'number'
        },
        operatingSystem: {
          type: 'number'
        },
        requiredHardware: {
          type: 'array',
          items: {
            type: 'string'
          }
        },
        optionalHardware: {
          type: 'array',
          items:{
            type: 'string'
          }
        },
        requiredSoftware: {
          type: 'array',
          items:{
            type:'string'
          }
        },
        optionalSoftware:{
          type: 'array',
          items:{
            type: 'string'
          }
        },
        fussFactor: {
          type: 'number'
        },
        fussFactorDescription: {
          type: 'string'
        },
        easeOfLearning: {
          type: 'number'
        },
        requiresTouch: {
          type: 'boolean'
        },
        forceRequired: {
          type: 'number'
        },
        requiredSites: {
          type: 'array',
          items: {
            type: 'string'
          }
        },
        feedbackAvailable: {
          type: 'number'
        },
        precisionRequired: {
          type: 'number'
        },
        robustness: {
          type: 'number'
        },
        mountingConsiderations: {
          type: 'string'
        },
        preferred: {
          type: 'boolean'
        },
        variability: {
          type: 'number'
        },
        variabilityDescription: {
          type: 'string'
        },
        cost: {
          type: 'number'
        },
        visualConsiderations: {
          type: 'string'
        },
        hearingConsiderations: {
          type: 'string'
        },
        cognitiveConsiderations: {
          type: 'string'
        },
        otherConsiderations: {
          type: 'string'
        },
        updatedAt: {
          type: 'number',
          minimum: 0,
          maximum: 1000000000000000,
          multipleOf: 1
        }
      },
      indexes: [['id'], ['username', 'updatedAt']],
      required: ['id', 'updatedAt'],
};

const personSchema = 
{    
    title: 'person',
    primaryKey: 'id',
    type: 'object',
    version: 16,
    properties: {
      id: {
          type: 'string',
          maxLength: 36
      },
      username: {
        type: 'string',
        unique: true
      },
      alias:{
        type: 'string'
      },
      email:{
        type:'string'
      },
      password:{
        type:'string'
      },
      role:{
        type: 'number'
      },
      pronouns:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      sessionIds:{
        type: 'array',
        items:{
          type: 'string'
        }
      },
      relationIds:{
        type:'array',
        items:{
          type:'string'
        }
      },
      onlyAvailableLocally:{
        type: 'boolean'
      },
      token: {
        type: 'string',
        maxLength: 36
      },
      tokenExpiration: {
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      },
      updatedAt: {
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      }
  },
  indexes: [['id'], ['username'], ['email'], ['updatedAt'], ["token"], ["relationIds"]],
  required: ['id', 'updatedAt'],
  encrypted:['email', 'password']
};

const sessionSchema = 
{    
  title: 'session',
  primaryKey: 'id',
  type: 'object',
  version: 16,
  properties: {
      id: {
      type: 'string',
      maxLength: 36
    },
    start:{
      type: 'number',
      minimum: 0,
      maximum: 1000000000000000,
      multipleOf: 1          
    },
    end:{
      type: 'number',
      minimum: 0,
      maximum: 1000000000000000,
      multipleOf: 1          
    },
    clinicianId:{
      type:'string'
    },
    clientId:{
      type:'string'
    },
    goalIds:{
      type:'array',
      items:{
        type: 'string'
      }
    },
    platforms:{
      type: 'array',
      items:{
        type:'string'
      }
    },
    platformsUsed:{
      type: 'array',
      items:{
        type:'string'
      }
    },
    characteristicsId:{
      type: 'string'
    },
    locations:{
      type: 'array',
      items:{
        type:'string'
      }
    },
    positions:{
      type: 'array',
      items:{
        type:'string'
      }
    },
    independentSetup:{
      type:'string'
    },
    independentUse:{
      type:'string'
    },
    firstMethodCategory:{
      type:'string'
    },
    historyIds:{
      type:'array',
      items:{
        type:'string'
      }
    },
    trialIds:{
      type:'array',
      items:{
        type:'string'
      }
    },
    summaryNotes:{
      type:'string'
    },
    backgroundNotes:{
      type:'string'
    },
    abilitiesNotes:{
      type:'string'
    },
    testdrivesNotes:{
      type:'string'
    },
    decisionsNotes:{
      type:'string'
    },
    recommendationsNotes:{
      type:'string'
    },
    clinicianIds:{
      type:'array',
      items:{
        type:'string'
      }
    },
    onlyAvailableLocally:{
      type: 'boolean'
    },
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 1000000000000000,
      multipleOf: 1
    }
  },
  indexes:[
    ['id'],
    ['updatedAt', 'id'],
    ['updatedAt', 'clientId']
  ],
  required: ['id', 'updatedAt'],
};

const clientAccessMethodSchema = 
{    
  title: 'clientAccessMethod',
  primaryKey: 'id',
  type: 'object',
  version: 14,
  properties: {
      id: {
        type:'string',
        maxLength: 36
      },
      name:{
        type:'string'
      },
      alias:{
        type: 'string'
      },
      currentlyUsed: {
        type:'boolean'
      },
      previouslyUsed:{
        type:'boolean'
      },
      accessMethodId:{
        type:'string'
      },
      productName:{
        type:'string'
      },
      bodySite:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      bodySiteComments:{
        type:'string'
      },
      satisfaction:{
        type:'number'
      },
      independentSetup:{
        type:'string'
      },
      independentUse:{
        type:'string'
      },
      notes:{
        type:'string'
      },
      positioningNotes: {
        type:'string'
      },
      accessMethodReadableId: {
        type:'string'
      },
      accessMethodCategory: {
        type:'string'
      },
      selectionMethod:{
        type:'string'
      },
      possibleSelectionMethods:{
        type: 'array',
        items:{
          type:'string'
        }
      },
      accessories:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      clinicianIds:{
        type:'array',
        items:{
          type:'string'
        }
      },
      onlyAvailableLocally:{
        type: 'boolean'
      },
      updatedAt: {
        type:'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      }
    },
    indexes: [['id'],['id', 'updatedAt']],
    required: ['id', 'updatedAt'],
};

const clientCharacteristicsSchema = 
{    
    title: 'clientCharacteristics',
    primaryKey: 'id',
    type: 'object',
    version: 10,
    properties: {
        id: {
          type: 'string',
          maxLength: 36
        },
        bodySites:{
          type: 'array',
          items: {
            type: 'string'
          }
        },
        bodySiteComments:{
          type:'string'
        },
        visionId:{
          type: 'string'
        },
        languageCognition:{
          type: 'array',
          items: {
            type: 'string'
          }
        },
        other:{
          type: 'string'
        },
        clinicianIds:{
          type:'array',
          items:{
            type:'string'
          }
        },
        onlyAvailableLocally:{
          type: 'boolean'
        },
        updatedAt: {
          type: 'number',
          minimum: 0,
          maximum: 1000000000000000,
          multipleOf: 1
      }
    },
    indexes: [['id'], ['id', 'updatedAt']],
    required: ['id', 'updatedAt'],
};

const visionClientCharacteristicsSchema = 
{    
    title: 'visionClientCharacteristics',
    primaryKey: 'id',
    type: 'object',
    version: 10,
    properties: {
        id: {
            type: 'string',
            maxLength: 36
          },
          wearsGlasses:{
            type: 'string'
          },
          betterWithGlasses:{
            type: 'string'
          },
          hasOtherVisualAids:{
            type: 'string'
          },
          visualAidsNotes: {
            type: 'string'
          },
          formalEvalNotes:{
            type: 'string'
          },
          visionIssues:{
            type: 'array',
            items: {
              type: 'string'
            }
          },
          issuesNotes:{
            type: 'string'
          },
          clinicianIds:{
            type:'array',
            items:{
              type:'string'
            }
          },
          onlyAvailableLocally:{
            type: 'boolean'
          },
          updatedAt: {
            type: 'number',
            minimum: 0,
            maximum: 1000000000000000,
            multipleOf: 1
        }
    },
    indexes: [['id'], ['id', 'updatedAt']],
    required: ['id', 'updatedAt'],
};

const clientGoalSchema = 
{    
    title: 'clientGoal',
    primaryKey: 'id',
    type: 'object',
    version: 9,
    properties: {
        id: {
          type: 'string',
          maxLength: 36
        },
        priority:{
          type: 'number'
        },
        type:{
          type: 'number'
        },
        task:{
          type: 'string'
        },
        clinicianIds:{
          type:'array',
          items:{
            type:'string'
          }
        },
        onlyAvailableLocally:{
          type: 'boolean'
        },
        updatedAt: {
          type: 'number',
          minimum: 0,
          maximum: 1000000000000000,
          multipleOf: 1
        }
    },
    indexes: [['id'], ['id', 'updatedAt']],
    required: ['id', 'updatedAt']
};

const trialSchema = 
{    
    title: 'trial',
    primaryKey: 'id',
    type: 'object',
    version: 16,
    properties: {
      id: {
        type: 'string',
        maxLength: 36
      },
      start:{
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1        
      },
      end:{
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1        
      },
      deviceId:{
        type: 'string'
      },
      trialTaskIds:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      reviewIds:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      issues:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      needsMet:{
        type: 'array',
        items: {
          type: 'string'
        }
      },
      comments:{
        type:'string'
      },
      nextSteps:{
        type:'string'
      },
      priorityActivity:{
        type:'string'
      },
      isProspect: {
        type: 'boolean'
      },
      isPick: {
        type: 'boolean'
      },
      clinicianIds:{
        type:'array',
        items:{
          type:'string'
        }
      },
      onlyAvailableLocally:{
        type: 'boolean'
      },
      updatedAt: {
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
        }
    },
    indexes: [['id'], ['id', 'updatedAt']],
    required: ['id', 'updatedAt']
};

const trialReviewSchema = 
{    
    title: 'trialReview',
    primaryKey: 'id',
    type: 'object',
    version: 14,
    properties: {
      id: {
        type: 'string',
        maxLength: 36
      },
      time:{
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      },
      reviewerId:{
        type:'string'
      },
      trialId:{
        type: 'string'
      },
      rating:{
        type:'string'
      },
      feedback:{
        type:'string'
      },
      clinicianIds:{
        type:'array',
        items:{
          type:'string'
        }
      },
      onlyAvailableLocally:{
        type: 'boolean'
      },
      updatedAt: {
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      }
    },
    indexes:[
      ['id'],
      ['trialId', 'reviewerId']
    ],
    required: ['id', 'updatedAt']
};

const trialTaskSchema = 
{    
    title: 'trialTask',
    primaryKey: 'id',
    type: 'object',
    version: 23,
    properties: {
      id: {
        type: 'string',
        maxLength: 36
      },
      start:{
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1        
      },
      end:{
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1        
      },
      type:{
        type:'string'
      },
      name:{
        type:'string'
      },
      numTexts:{
        type:'string'
      },
      language:{
        type:'string'
      },
      textUnit:{
        type:'string'
      },
      numTargets:{
        type:'string'
      },
      targetSize:{
        type:'string'
      },
      targetType:{
        type:'string'
      },
      numPrompts:{
        type:'string'
      },
      promptType:{
        type:'string'
      },
      description:{
        type:'string'
      },
      taskNotes:{
        type: 'string'
      },
      wordsPerMinute:{
        type:'string'
      },
      rawWordsPerMinute:{
        type:'string'
      },
      targetsPerMinute:{
        type:'string'
      },
      timePerTarget:{
        type:'string'
      },
      accuracy:{
        type:'string'
      },
      duration:{
        type:'string'
      },
      difficulty: {
        type:'string'
      },
      extraActivations: {
        type:'string'
      },
      trialTaskComponentIds: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      completed:{
        type: 'boolean'
      },
      clinicianIds:{
        type:'array',
        items:{
          type:'string'
        }
      },
      onlyAvailableLocally:{
        type: 'boolean'
      },
      updatedAt: {
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      }
    },
    indexes:[
      ['id']
    ],
    required: ['id', 'updatedAt']
};

const trialTaskComponentSchema = 
{    
    title: 'trialTaskComponent',
    primaryKey: 'id',
    type: 'object',
    version: 11,
    properties: {
      id: {
        type: 'string',
        maxLength: 36
      },
      trialTaskId:{
        type: 'string',
      },
      index:{
        type: 'number'
      },
      sentence:{
        type:'string'
      },
      duration:{
        type: 'number'
      },
      targetTextLength:{
        type:'number'
      },
      totalWords:{
        type:'number'
      },
      totalSelections:{
        type:'number'
      },
      minStringDistance:{
        type:'number'
      },
      targetEntries:{
        type:'number'
      },
      clicks:{
        type:'number'
      },
      activationType:{
        type: 'string'
      },
      trialTime:{
        type:'number'
      },
      reactionTime:{
        type:'number'
      },
      holdTime:{
        type:'number'
      },
      hiddenTime:{
        type:'number'
      },
      awaitedRelease:{
        type:'boolean'
      },
      extraActivations:{
        type:'number'
      },
      clinicianIds:{
        type:'array',
        items:{
          type:'string'
        }
      },
      onlyAvailableLocally:{
        type: 'boolean'
      },
      updatedAt: {
        type: 'number',
        minimum: 0,
        maximum: 1000000000000000,
        multipleOf: 1
      }
    },
    indexes:[
      ['id']
    ],
    required: ['id', 'updatedAt']
};

const graphQLGenerationInput = {
  accessMethod: {
      schema: accessMethodSchema,
      feedKeys: [
        'id',
        'updatedAt'
      ],
      checkpointFields:[
        'id',
        'updatedAt'
      ],
      deletedField: 'deleted',
      headerFields: ['Authorization']
  },
  clientAccessMethod:{
    schema: clientAccessMethodSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  clientCharacteristics:{
    schema: clientCharacteristicsSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  clientGoal:{
    schema: clientGoalSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  person:{
    schema: personSchema,
    feedKeys: [
        'id',
        'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'relationIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', 'relationIds']
  },
  session:{
    schema: sessionSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianId',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  trial:{
    schema: trialSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  trialReview:{
    schema: trialReviewSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  trialTask:{
    schema: trialTaskSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  trialTaskComponent:{
    schema: trialTaskComponentSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  },
  visionClientCharacteristics:{
    schema: visionClientCharacteristicsSchema,
    feedKeys: [
      'id',
      'updatedAt'
    ],
    checkpointFields:[
      'id',
      'updatedAt',
      'clinicianIds'
    ],
    deletedField: 'deleted',
    headerFields: ['Authorization', "clinicianIds"]
  }
};

module.exports = {
    GRAPHQL_PATH,
    GRAPHQL_SUBSCRIPTION_PATH,
    JWT_PRIVATE_KEY,
    JWT_BEARER_TOKEN,
    accessMethodSchema,
    clientAccessMethodSchema,
    clientCharacteristicsSchema,
    clientGoalSchema,
    personSchema,
    sessionSchema,
    trialSchema,
    trialReviewSchema,
    trialTaskSchema,
    trialTaskComponentSchema,
    visionClientCharacteristicsSchema,
    graphQLGenerationInput
};
